import { Submission, SubmissionUpdate, UserOnboarding } from "types/userTypes";
import { UserActionType } from "../action-types/userActionTypes";
import {
  USER_SET_IS_ACTIVE,
  USER_SET_LOG_OUT,
  USER_SET_ORG,
  USER_SET_ROLE,
  USER_SET_FORCE_PASS_CHANGE,
  USER_SET_SUBMISSIONS,
  USER_APPROVE_OR_DENY_SUBMISSION,
  USER_REQUEST_SUBMISSIONS,
  USER_CANCEL_SUBMISSION,
  USER_SET_DISTRIBUTOR_ID,
  USER_SET_ONBOARDING,
} from "../constants";

export const setUserRole = (payload: string): UserActionType => ({
  type: USER_SET_ROLE,
  payload,
});

export const setUserOrg = (payload: string): UserActionType => ({
  type: USER_SET_ORG,
  payload,
});

export const setIsActive = (payload: boolean): UserActionType => ({
  type: USER_SET_IS_ACTIVE,
  payload,
});

export const setForcePassChange = (payload: boolean): UserActionType => ({
  type: USER_SET_FORCE_PASS_CHANGE,
  payload,
});

export const logOut = (redirectPath?: string): UserActionType => ({
  type: USER_SET_LOG_OUT,
  payload: redirectPath,
});

export const setSubmissions = (payload: Submission[]): UserActionType => ({
  type: USER_SET_SUBMISSIONS,
  payload,
});

export const requestFetchSubmissions = (): UserActionType => ({
  type: USER_REQUEST_SUBMISSIONS,
});

export const approveOrDenySubmission = (payload: SubmissionUpdate): UserActionType => ({
  type: USER_APPROVE_OR_DENY_SUBMISSION,
  payload,
});

export const cancelSubmission = (submissionId: string): UserActionType => ({
  type: USER_CANCEL_SUBMISSION,
  payload: submissionId,
});

export const setUserDistributorId = (payload: string | null): UserActionType => ({
  type: USER_SET_DISTRIBUTOR_ID,
  payload,
});

export const setUserOnboarding = (payload: UserOnboarding | null): UserActionType => ({
  type: USER_SET_ONBOARDING,
  payload,
});
